/// <reference path="../typings.d.ts" />
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppTitle } from './shared/title';
import { Account } from './services/account.service';
import { Config } from './config';
import { IdentityService } from './services/identity.service';
import { Alert } from './shared/alert';
import { Subscription } from 'rxjs';

@Component({
  selector: 'dashboard',
  template: `
	<div class="col-lg-3 col-md-6 col-xs-12">
		<alert [alert]="msg"></alert>
	  <h1>dashboard</h1>
	</div>
  `
})

export class DashboardComponent implements OnDestroy {
  private subscription: Subscription;
  msg: Alert;
  acctNumber: string;

  constructor(private router: Router, private title: AppTitle, private account: Account, private activatedRoute: ActivatedRoute, private config: Config, private dvc: IdentityService) {
    this.msg = new Alert();
    title.setTitles({ title: 'Dashboard', dashboard: 'Dashboard', dashboardNav: 'Home' });

    this.subscription = activatedRoute.params.subscribe(
      (params) => this.acctNumber = params['acctNumber']
    )

    if (this.acctNumber != null) {
      dvc.validateAcctNumber(this.acctNumber)
        .subscribe(res => {
        }, err => {
          console.log(err);
          this.msg.error('There is an error when processing this request, please try again.');
        });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
